/** @format */

import i18n, { LanguageDetectorModule } from "i18next";
import { initReactI18next } from "react-i18next";
import stringsEn from "./locales/strings.en.json";
import stringsCy from "./locales/strings.cy.json";

/**
 * Types
 */
export type Locale = "en" | "cy";
export interface LocaleText {
  en: string;
  cy: string;
}
/** The locales used */
export const locales: Locale[] = ["en", "cy"];

/** Set the Locale strings from the JSON */
const resources = {
  en: {
    translation: stringsEn,
  },
  cy: {
    translation: stringsCy,
  },
};

/**
 * A custom language detector. On first visit the locale will be set from the domain. a cbac.co.uk domain
 * will set it to Welsh, otherwise English.
 *
 * The last used locale will be set in localStorage and retrieved the next visit.
 */
export const DomainLanguageDetector: LanguageDetectorModule = {
  type: "languageDetector",
  init: (services, detectorOptions, i18nextOptions) => {},
  // If the host is a subdomain of cbac.co.uk return 'cy' by default.
  detect: () =>
    localStorage.getItem("WJEC-GQ_LOCALE") ||
    (!!window.location.host.match(/[.\w]+\.cbac\.co\.uk$/) ? "cy" : "en"),
  cacheUserLanguage: (lng) => {
    localStorage.setItem("WJEC-GQ_LOCALE", lng);
  },
};

/**
 * Initialise the i18n object. This object is then loaded at the earliest opportunity, i.e. in the index.tsx file.
 *
 * @see https://react.i18next.com/latest/i18next-instance
 */
i18n
  /** Plugins and extensions */
  .use(initReactI18next) // provided by react-i18next
  .use(DomainLanguageDetector) // our custom language detector

  /** initialise */
  .init({
    resources,
    // lng: savedLocale,
    fallbackLng: "en",
    supportedLngs: locales,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      lookupLocalStorage: "WJEC-GQ_LOCALE",
      // order: ['querystring', 'cookie', 'locslStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },
  });

export default i18n;
